/**
 * 已投递 Page
 */
import spendGameManager from "../../manager/spendGameManager";
import {NpcEventRel} from "../../config/SpendInterface";
import newProjectItem from "./newProjectItem";
import DreamHousePrefab from "../DreamHousePrefab";
import O1HD from "../../../../engines/gameEngine";
const {ccclass, property} = cc._decorator;
@ccclass
export default class PageNewProject extends cc.Component {

    @property(cc.ScrollView)
    scrollView: cc.ScrollView = null;
    @property(cc.Node)
    contentNode : cc.Node = null;
    @property(cc.Prefab)
    newProjectItem : cc.Prefab = null;

    private mGameLayer : spendGameManager;
    private mParentScript : DreamHousePrefab;

    onLoad () {
        O1HD.on("Page.refreshData" , this.refreshData , this );
    }

    start () {
        this.refreshData();
    }

    //
    bindData( gameLayer : spendGameManager ,parentScript : DreamHousePrefab){
        this.mGameLayer = gameLayer;
        this.mParentScript = parentScript;

    }

    /**
     * 添加Item
     * @param itemData
     */
    addItem( itemData : NpcEventRel ){
        let newProjectItemNode = cc.instantiate( this.newProjectItem );
        this.contentNode.addChild( newProjectItemNode  );
        newProjectItemNode.getComponent( newProjectItem ).bindData( itemData , this.mGameLayer , this.mParentScript );
    }

    /**
     * 刷新数据
     */
    refreshData(){
        this.contentNode.destroyAllChildren();
        for ( let npcEventItem of this.mGameLayer.getGameData()._currentEvents ){
            if ( npcEventItem.todayInvestCoins == 0 ) {
                this.addItem( npcEventItem );
            }
        }
    }

}
